import React, { useEffect, useState } from 'react'
import { Container, Grid, Paper, Typography, Button, Box, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import NestedUserHeader from '../component/reusable/NestedUserHeader';
import { getNotification, markAsRead, markAllAsRead, markAllSeen } from "../redux/notification/notification"
import { useNavigate } from 'react-router-dom';
import { format, isToday, isYesterday, formatDistanceToNow } from "date-fns";
import { useDispatch, useSelector } from 'react-redux';

const StyledGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: theme.shape.borderRadius,
}));


const Notifications = () => {

  const nav = useNavigate()
  const dispatch = useDispatch()

  const [showAll, setShowAll] = useState(false);
  const [activeTab, setActiveTab] = useState('All');
  const user = useSelector((state) => state.user);
  const { notificationData, notificationCountData, isRefresh } = useSelector((state) => state.notification)
  const [loaded, setLoaded] = useState(false);
  const userId = user?.user?._id

  const notificationGroup = (notification) => {
    const details = [
      notification?.notificationType,
      notification?.title,
      notification?.message,
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    if (details.includes('wizard')) return 'Wizard';
    if (details.includes('excess')) return 'Excess';
    if (details.includes('bom')) return 'BOM';
    if (details.includes('cart') || details.includes('order') || details.includes('schedule')) return 'Orders';
    if (details.includes('registration') || details.includes('user') || details.includes('vendor') || details.includes('account')) return 'Account';
    return 'Other';
  };

  const notificationTabs = ['All', 'BOM', 'Wizard', 'Excess', 'Orders', 'Account'];
  const visibleNotifications = activeTab === 'All'
    ? notificationData
    : notificationData?.filter((notification) => notificationGroup(notification) === activeTab);


  const handleMark = async (data) => {
    try {
      await dispatch(markAsRead(data))
      // await getNotification(user?.data?._id)

    } catch (error) {
      console.log(error.message);

    }
  }


  useEffect(() => {
    const fetchNotification = async () => {
      try {
        if (!userId) return
        await dispatch(getNotification({ body: userId, showAll: showAll }))
        setLoaded(true)
      } catch (error) {
        console.error("error occured", error)
      }
    }
    fetchNotification()
  }, [dispatch, isRefresh, userId, showAll])

  // Badge clears once the list has loaded (and again if a new one arrives while open).
  // The list keeps its unread dots for this visit.
  useEffect(() => {
    if (loaded && userId && notificationCountData > 0) {
      dispatch(markAllSeen(userId))
    }
  }, [dispatch, loaded, userId, notificationCountData])

  const formattedDate = (date = new Date()) => {
    const dateFromMongoDB = new Date(date);

    if (isToday(dateFromMongoDB)) {
      return `Today, ${format(dateFromMongoDB, "hh:mm a")}`;
    } else if (isYesterday(dateFromMongoDB)) {
      return `Yesterday, ${format(dateFromMongoDB, "hh:mm a")}`;
    } else {
      const differenceInDays = Math.floor(
        (new Date() - dateFromMongoDB) / (1000 * 60 * 60 * 24)
      );
      if (differenceInDays < 7) {
        return `${formatDistanceToNow(dateFromMongoDB)} ago`;
      } else {
        const formattedDate = format(dateFromMongoDB, "dd MMM yyyy");
        const formattedTime = format(dateFromMongoDB, "hh:mm a");
        return `${formattedDate}, ${formattedTime}`;
      }
    }
  };


  const handleMarkAll = async () => {
    try {
      if (user?.user?._id) {
        await dispatch(markAllAsRead(user?.user?._id))
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  const handleView = (notification) => {
    if (notification?.targetUrl) {
      nav(notification.targetUrl)
    } else if (notification?.notificationType == 'userregistration') {
      nav(`/users/customerDetails/${notification?.createrId}`)

    } else if (notification?.notificationType == 'vendorregistration') {
      nav(`/users/vendorDetails/${notification?.createrId}`)
    }else if(notification?.notificationType == 'BOM order'){
      nav(`/bom/BomOrderDetails/${notification?.createrId}`)
    
    }else if(notification?.notificationType == 'WIZARD order'){
      nav(`/wizard/wizardOrderDetails/${notification?.createrId}`)
    }
    else if(notification?.notificationType == 'EXCESS order'){
      nav(`/excess/excessOrderDetails/${notification?.createrId}`)
    }
    else if(notification?.notificationType == 'cart order'){
      nav(`/orders/orderDetails/${notification?.createrId}`)
    }
  }

  return (
    <div>
      <NestedUserHeader
        index="Notifications"
        root="admins"
        buttonText={'Back to list'} />

      <Paper sx={{ overflow: 'hidden' }}>
        <Grid item sx={{ padding: '20px 24px 14px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
            <Box>
              <Typography sx={{ fontSize: "20px", color: '#1A1A1A', fontWeight: 700 }}>Notifications center</Typography>
              <Typography sx={{ fontSize: '13px', color: '#667085', mt: 0.5 }}>Keep BOM, Wizard, excess inventory and order updates organised in one place.</Typography>
            </Box>
            {notificationData?.some((n) => !n?.isRead) && (
              <Button onClick={handleMarkAll} sx={{ color: '#512DA8', fontSize: "13px", textTransform: 'none', whiteSpace: 'nowrap' }}>Mark all as read</Button>
            )}
          </Box>
        </Grid>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', px: 3, py: 1.5, borderTop: '1px solid #EEF0F4', borderBottom: '1px solid #EEF0F4' }}>
          {notificationTabs.map((tab) => {
            const count = tab === 'All'
              ? notificationData?.length || 0
              : notificationData?.filter((notification) => notificationGroup(notification) === tab).length || 0;
            const isActive = activeTab === tab;

            return (
              <Button
                key={tab}
                onClick={() => setActiveTab(tab)}
                sx={{
                  minWidth: 0,
                  px: 2,
                  py: 0.75,
                  borderRadius: '20px',
                  color: isActive ? '#fff' : '#53657E',
                  backgroundColor: isActive ? '#512DA8' : '#F2F5F9',
                  fontSize: '13px',
                  fontWeight: 600,
                  textTransform: 'none',
                  '&:hover': { backgroundColor: isActive ? '#43218D' : '#E9EDF4' },
                }}
              >
                {tab} ({count})
              </Button>
            );
          })}
        </Box>
        {notificationData?.length === 0 && (
          <Typography sx={{ fontSize: "14px", color: '#A5ACB8', padding: '32px 24px' }}>No notifications yet</Typography>
        )}
        {notificationData?.length > 0 && visibleNotifications?.length === 0 && (
          <Typography sx={{ fontSize: '14px', color: '#667085', padding: '32px 24px' }}>No {activeTab.toLowerCase()} notifications yet.</Typography>
        )}
        {visibleNotifications?.map((notification) => (
          <React.Fragment key={notification?._id}>
            <Box sx={{ padding: '0px 24px' }} onClick={() => handleMark(notification._id)}>
              <StyledGrid container sx={{ display: 'flex', flexDirection: "column", alignItems: "flex-start", margin: "16px 0px" }}>
                <Grid sx={{ display: 'flex', alignItems: 'center', marginBottom: "10px" }}>
                  {!notification?.isRead && <Typography sx={{ marginRight: '6px', width: '10px', height: '10px', borderRadius: "50px", background: "#512DA8" }}></Typography>}
                  <Box>
                    {notification?.title && (
                      <Typography sx={{ fontSize: "15px", color: '#1A1A1A', fontWeight: 600 }}>
                        {notification.title}
                      </Typography>
                    )}
                    <Typography sx={{ fontSize: "14px", color: notification?.title ? '#4D4D4D' : '#1A1A1A', }}>
                      {notification?.message}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item sx={{ display: 'flex', gap: 1, marginLeft: '16px', marginBottom: "10px" }}>
                  {/* <Button sx={{ color: '#fff', fontSize: "12px", textTransform: 'capitalize', background: '#111111' }}  >Accept</Button>
           <Button sx={{ color: '#3C4257', fontSize: "12px", textTransform: 'capitalize', border: '1px solid #DDDEE1' }}  >Reject</Button> */}
                  <Button onClick={() => handleView(notification)} sx={{ color: '#fff', fontSize: "12px", textTransform: 'capitalize', background: '#111111' }}  >View</Button>

                </Grid>
                <Typography sx={{ fontSize: "14px", color: '#A5ACB8', marginLeft: '16px' }}>
                  {formattedDate(notification.createdAt)}
                </Typography>
              </StyledGrid >
            </Box>
            <Divider sx={{ mb: 1 }} />
          </React.Fragment>
        ))}

        {!showAll && (<Button sx={{ color: '#512DA8', fontSize: "14px", textTransform: 'capitalize', marginLeft: '10px' }} onClick={() => setShowAll(true)} >View all</Button>)}

      </Paper>
    </div>
  )
}

export default Notifications
